const ENDPOINT = 'landing-pages';

export const landingPagesApiFactory = ({ callPostApi, callGetApi, callDeleteApi }) => ({
    createLandingPage: ({ accountId: _accountId, accountName, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}`, {
            ...lpPayload,
        });
    },
    getLandingPage: ({ accountName, landingPageId }) => {
        return callGetApi(`/${accountName}/${ENDPOINT}/${landingPageId}`);
    },
    getAllLandingPages: ({ accountName }) => {
        return callGetApi(`/${accountName}/${ENDPOINT}`);
    },
    editLandingPage: ({ accountName, landingPageId, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}`, {
            ...lpPayload,
        });
    },
    chatEditLandingPage: ({ accountName, landingPageId, prompt, activeVersionNumber }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}/chat`, {
            prompt,
            activeVersionNumber,
        });
    },
    duplicateLandingPage: ({ accountName, landingPageId, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}/duplicate`, {
            ...lpPayload,
        });
    },
    deleteLandingPage: ({ accountName, landingPageId }) => {
        return callDeleteApi(`/${accountName}/${ENDPOINT}/${landingPageId}`);
    },
    getVersions: ({ accountName, landingPageId }) => {
        return callGetApi(`/${accountName}/${ENDPOINT}/${landingPageId}/versions`);
    },
    navigateToVersion: ({ accountName, landingPageId, versionNumber }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}/version/${versionNumber}`);
    },
    listPromptTemplates: ({ accountName, tagType }) => {
        const params = tagType ? `?tagType=${tagType}` : '';
        return callGetApi(`/${accountName}/${ENDPOINT}/prompt-templates${params}`);
    },
});
